<template>
  <div class="s-invite" :style="{...defaultBg.style}">
    <div class="s-topic-bg-wrap">
      <SAnimateImage :width="defaultBg.style.width" :height="defaultBg.style.height" :src="defaultBg.src" mask=""></SAnimateImage>
    </div>
    <img v-if="btnInvite.src" :src="btnInvite.src" :style="{...btnInvite.style}" alt="" class="btn-invite" @click="inviteFun">
    <SVersionModalInviteTeam :activityId="this.activityId" ref="SVersionModalInviteTeam" @inviteSuccess="inviteSuccess" />
  </div>
</template>

<script>

import SAnimateImage from '../AnimateImage/index.vue'
import SVersionModalInviteTeam from './_components/VersionModalInviteTeam.vue'

export default {
  name: 'SVersionInvite',
  components: { SVersionModalInviteTeam, SAnimateImage },
  props: {
    activityId: {
      type: String,
      default: ''
    },
    dailogText: {
      type: String,
      default: ''
    },
    defaultBg: {
      type: Object,
      required: true
    },
    btnInvite: {
      type: Object,
      default: () => {
        return {}
      }
    },
    shareText: {
      type: String,
      default: ''
    },
    request: {
      type: Function
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    this.$refs.SVersionModalInviteTeam.getShareCode(this.dailogText)
  },
  computed: {
  },
  methods: {
    inviteFun () {
      this.$refs.SVersionModalInviteTeam.open({
        tipText: this.shareText
      })
    },
    // 邀请成功
    inviteSuccess () {
      this.$MainWrap.init && this.$MainWrap.init()
    }
  }
}
</script>
<style lang="scss" scoped>
.s-invite{
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  position: relative;
}
</style>
